var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCollectionGallery(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "160px",
    height: "108px",
    viewBox: "0 0 160 108",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Collection Gallery") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Row-Menu",
    transform: "translate(-48.000000, -1420.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Collection-Gallery",
    transform: "translate(48.000000, 1420.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#CDD4DA",
    x: 0.5,
    y: 0.5,
    width: 159,
    height: 107
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(6.000000, 6.000000)",
    fill: "#8C9BA8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 72,
    height: 96
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(82.000000, 6.000000)",
    fill: "#8C9BA8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 72,
    height: 96
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon/Layer/M/White-Default",
    transform: "translate(30.000000, 42.000000)",
    filter: "url(#filter-1)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0,
    transform: "translate(12.000000, 12.000000) rotate(180.000000) translate(-12.000000, -12.000000) ",
    x: -1.77635684e-15,
    y: 1.77635684e-15,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21,11.35 C20.9765851,10.9707169 20.7402194,10.63748 20.39,10.49 L18.24,9.57 L20.5,8.27 C20.8267322,8.08207138 21.0200371,7.7263902 21,7.35 C20.9765851,6.97071689 20.7402194,6.63747995 20.39,6.49 L12.39,3.08 C12.1407184,2.97441981 11.8592816,2.97441981 11.61,3.08 L3.61,6.49 C3.25978064,6.63747995 3.02341491,6.97071689 3,7.35 C2.97996285,7.7263902 3.17326784,8.08207138 3.5,8.27 L5.76,9.57 L3.61,10.49 C3.25978064,10.63748 3.02341491,10.9707169 3,11.35 C2.97996285,11.7263902 3.17326784,12.0820714 3.5,12.27 L5.76,13.57 L3.61,14.49 C3.25978064,14.63748 3.02341491,14.9707169 3,15.35 C2.97996285,15.7263902 3.17326784,16.0820714 3.5,16.27 L11.5,20.87 C11.8094011,21.0486328 12.1905989,21.0486328 12.5,20.87 L20.5,16.27 C20.8267322,16.0820714 21.0200371,15.7263902 21,15.35 C20.9765851,14.9707169 20.7402194,14.63748 20.39,14.49 L18.24,13.57 L20.5,12.27 C20.8267322,12.0820714 21.0200371,11.7263902 21,11.35 L21,11.35 Z M12,5.09 L17.76,7.54 L12,10.85 L6.24,7.54 L12,5.09 Z M11.5,12.87 C11.8094011,13.0486328 12.1905989,13.0486328 12.5,12.87 L16.07,10.87 L17.76,11.59 L12,14.85 L6.24,11.54 L7.93,10.82 L11.5,12.87 Z M17.76,15.54 L12,18.85 L6.24,15.54 L7.93,14.82 L11.5,16.87 C11.8094011,17.0486328 12.1905989,17.0486328 12.5,16.87 L16.07,14.82 L17.76,15.54 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Icon/Layer/M/White-Default",
    transform: "translate(106.000000, 42.000000)",
    filter: "url(#filter-2)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0,
    transform: "translate(12.000000, 12.000000) rotate(180.000000) translate(-12.000000, -12.000000) ",
    x: -1.77635684e-15,
    y: 1.77635684e-15,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21,11.35 C20.9765851,10.9707169 20.7402194,10.63748 20.39,10.49 L18.24,9.57 L20.5,8.27 C20.8267322,8.08207138 21.0200371,7.7263902 21,7.35 C20.9765851,6.97071689 20.7402194,6.63747995 20.39,6.49 L12.39,3.08 C12.1407184,2.97441981 11.8592816,2.97441981 11.61,3.08 L3.61,6.49 C3.25978064,6.63747995 3.02341491,6.97071689 3,7.35 C2.97996285,7.7263902 3.17326784,8.08207138 3.5,8.27 L5.76,9.57 L3.61,10.49 C3.25978064,10.63748 3.02341491,10.9707169 3,11.35 C2.97996285,11.7263902 3.17326784,12.0820714 3.5,12.27 L5.76,13.57 L3.61,14.49 C3.25978064,14.63748 3.02341491,14.9707169 3,15.35 C2.97996285,15.7263902 3.17326784,16.0820714 3.5,16.27 L11.5,20.87 C11.8094011,21.0486328 12.1905989,21.0486328 12.5,20.87 L20.5,16.27 C20.8267322,16.0820714 21.0200371,15.7263902 21,15.35 C20.9765851,14.9707169 20.7402194,14.63748 20.39,14.49 L18.24,13.57 L20.5,12.27 C20.8267322,12.0820714 21.0200371,11.7263902 21,11.35 L21,11.35 Z M12,5.09 L17.76,7.54 L12,10.85 L6.24,7.54 L12,5.09 Z M11.5,12.87 C11.8094011,13.0486328 12.1905989,13.0486328 12.5,12.87 L16.07,10.87 L17.76,11.59 L12,14.85 L6.24,11.54 L7.93,10.82 L11.5,12.87 Z M17.76,15.54 L12,18.85 L6.24,15.54 L7.93,14.82 L11.5,16.87 C11.8094011,17.0486328 12.1905989,17.0486328 12.5,16.87 L16.07,14.82 L17.76,15.54 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCollectionGallery);
export default __webpack_public_path__ + "static/media/icon_collection_gallery.5d9a4f6b.svg";
export { ForwardRef as ReactComponent };